import { render } from "./AposLocale.vue?vue&type=template&id=767f2d38&scoped=true"
import script from "./AposLocale.vue?vue&type=script&setup=true&lang=js"
export * from "./AposLocale.vue?vue&type=script&setup=true&lang=js"

import "./AposLocale.vue?vue&type=style&index=0&id=767f2d38&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767f2d38"],['__file',"ui/ui/apos/components/AposLocale.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "767f2d38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('767f2d38', __exports__)) {
    api.reload('767f2d38', __exports__)
  }
  
  module.hot.accept("./AposLocale.vue?vue&type=template&id=767f2d38&scoped=true", () => {
    api.rerender('767f2d38', render)
  })

}


export default __exports__